import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Link from './Link';

const TagButton = ({
  tag = null, count, onClick, className,
}) => (tag && tag.id && (
  <Link
    href={`/questions?${tag.type}=${tag.id}`}
    onClick={onClick}
    className={cx(`
          py-1
          px-2
          mr-2
          bg-gray-100
          text-sm
          font-medium
          text-gray-600
          rounded
          whitespace-nowrap
          hover:bg-gray-200
          hover:text-gray-800
        `, className)}
  >
    <span>
      {tag.name}
    </span>
    {count && (
      <span className="border-l border-gray-300 ml-1.5 pl-1.5 text-xs text-gray-500">{count}</span>
    )}
  </Link>
));

TagButton.propTypes = {
  tag: PropTypes.shape({
    id: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
};

export default TagButton;
